import { DirectionalLight as e, AmbientLight as i, MainCamera as r, RenderContext as t, Renderer as n } from "./components.js";
import { rendererRecipe as o } from "./recipes.js";
import { MeshInstanceSystem as s, LightSyncSystem as a, CameraSyncSystem as c, WebGLRenderSystem as m } from "./systems.js";
const g = {
  recipes: [o],
  systems: [
    s,
    a,
    c,
    m
  ],
  components: {
    Renderer: n,
    RenderContext: t,
    MainCamera: r,
    AmbientLight: i,
    DirectionalLight: e
  },
  config: {
    defaults: {
      ambientLight: {
        skyColor: 8900331,
        groundColor: 4868682,
        intensity: 0.6
      },
      directionalLight: {
        color: 16777215,
        intensity: 1,
        castShadow: 1,
        shadowMapSize: 4096,
        directionX: -1,
        directionY: 2,
        directionZ: -1,
        distance: 30
      },
      renderer: {
        visible: 1,
        sizeX: 1,
        sizeY: 1,
        sizeZ: 1,
        color: 16777215,
        unlit: 0
      },
      mainCamera: {
        projection: 0,
        fov: 75,
        orthoSize: 10
      }
    },
    enums: {
      renderer: {
        shape: {
          box: 0,
          sphere: 1
        }
      },
      mainCamera: {
        projection: {
          perspective: 0,
          orthographic: 1
        }
      }
    }
  }
};
export {
  g as RenderingPlugin
};
//# sourceMappingURL=plugin.js.map
